export function register() {
  const mobileNavBtn = document.getElementById("mobile-nav-btn");
  const mobileNavMenu = document.getElementById("mobile-nav-menu");

  mobileNavBtn?.addEventListener("click", () => {
    const isOpen = !mobileNavMenu.classList.contains("hidden");
    mobileNavMenu.classList.toggle("hidden");
    document.body.style.overflow = isOpen ? "" : "hidden";
  });
}
